import {useTheme} from "@mui/material/styles";
import {Box} from "@mui/material";
import FaIcon from "@/components/utilities/fa-icon";
import React from "react";

export default function SliderIcon(
    {faIcon, iconColor, bgSec}: {
        bgSec: boolean,
        faIcon: string,
        iconColor?: string
    }
) {
    const theme = useTheme()

    return (
        <Box
            bgcolor = {theme.palette.primary.light}
            borderRadius = {theme.shape.borderRadius}
            width = {22}
            height = {22}
            mb = {2}
            mr = {2.5}
            display = 'flex'
            alignItems = 'end'
        >

            <FaIcon
                fontSize = {42}
                color = {bgSec ? theme.palette.background.default : iconColor ? iconColor : theme.palette.primary.dark}
                faIcon = {faIcon} />
        </Box >
    )
}